<template>
    <div class="container">
        <section class="pedido-steps">
            <div class="row">
                <div class="col-12">
                <div class="return d-block d-sm-none">
                    <router-link to="/">
                    <img :src="require('../../../assets/img/backspace.svg')" class="mb-5">
                    </router-link>
                </div>
                <div class="section-title">
                    <h5 class="pull-left" title="Ajuda sobre o histórico de preços">
                    {{ $t('home.pricing_title') }}
                    </h5>
                    <router-link to="/">
                    <img class="d-none d-sm-block" :src="require('../../../assets/img/backspace.svg')">
                    </router-link>
                </div>
                </div>
            </div>

            <div v-if="this.pricing" class="row index-option pricing-container">
              <div class="col-md-3" v-if="this.vendor">
                <router-link :to="route + 'nuevo-precio'">
                  <div class="box-pedido">
                    <img :src="require('@/assets/img/pedidos2.png')" alt="pedidos3">
                    <h3>{{ $t('pricing.nprecio') }}</h3>
                  </div>
                </router-link>
              </div>
              
              <div class="col-md-3">
                <router-link :to="route + 'mis-precios'">
                  <div class="box-pedido">
                    <img :src="require('@/assets/img/pedidos1.png')" alt="pedidos3">
                    <h3>{{ $t('pricing.mprecios') }}</h3>
                  </div>
                </router-link>
              </div>

              <div class="col-md-3">
                <router-link :to="route + 'precios-historico'">
                  <div class="box-pedido">
                    <img :src="require('@/assets/img/pricehistory.png')" alt="pedidos3">
                    <h3>{{ $t('pricing.history.title') }}</h3>
                  </div>
                </router-link>
              </div>

              <div class="col-md-3">
                <router-link :to="route + 'precios-competencia'">
                  <div class="box-pedido">
                    <img :src="require('@/assets/img/pedidos3.png')" alt="pedidos3">
                    <h3>{{ $t('pricing.competition.title') }}</h3>
                  </div>
                </router-link>
              </div>

              <div class="col-md-3" v-if="this.pricing_admin">
                <router-link :to="route + 'importador'">
                  <div class="box-pedido">
                    <img :src="require('@/assets/img/pedidos2.png')" alt="pedidos3">
                    <h3>{{ $t('pricing.importador.title') }}</h3>
                  </div>
                </router-link>
              </div>
            </div>
        </section>
    </div>
</template>
<script>
import {route} from "@/enviroment"
import axios from "axios";
import {TDC_ROLES} from "@/router";
import {PRICING_ROLES} from "@/router";

export default {
  name: "HomePage",
  props: {},
  data() {
    return {
      route: route,
      rs: false,
      tdc: false,
      pricing: false,
      vendor: false,
      pricing_admin: false,
    }
  },
  async created() {
    await this.getUserRole();
  },
  methods: {
    getUserRole() {
      const profile = sessionStorage.getItem('mccain_service_user_profile');
      if (profile) {
        const data = JSON.parse(profile);
        this.rs = !!data.Admin_RS || !!data.User_RS;
        this.tdc = data.tdcprofile && TDC_ROLES.includes(data.tdcprofile.toString().toLowerCase());
        this.pricing = data.Princing_profile && PRICING_ROLES.includes(data.Princing_profile);
        this.vendor = data.Princing_profile === PRICING_ROLES[0];
        this.pricing_admin = data.Princing_profile === PRICING_ROLES[3] || data.Princing_profile === PRICING_ROLES[4];
      }
    },
    logout() {
      axios.get(
          '/auth/logout'
      ).then(() => {
        window.localStorage.clear();
        location.href = route + "login";
      });
    },
  },
}
</script>

<style scoped>
  .box-pedido{
    height: 220px;
  }
  .box-pedido img{
    max-width: 100px;
  }
</style>